import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.get(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetProcesosJudiciales = async (query) => {
    try {
        const response = await client.get(`proceso-judicial?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetCombos = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetTribunales = async (query) => {
    try {
        const response = await client.get(`tribunales?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetImplicadosTerceros = async(query) => {
    try {
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}

export const serviceGetCasoImplicado = async(query) => {
    try {
        const response = await client.getCasoImplicado(`caso/implicado?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}

export const serviceAddProcesoJudicial = async(body) => {
    try {
        const response = await client.post('proceso-judicial', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}

export const serviceGetGestionImpicado = async(query) => {
    try {
        const response = await client.get(`getion-implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } 
    catch(error){
        throw error;
    }
}

export const serviceGetHitosJudiciales = async(query) => {
    try {
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } 
    catch(error){
        throw error;
    }
}

export const serviceGetHistorialHitos = async(query) => {
    try {
        const response = await client.get(`getion-implicado/contacto/hitos?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } 
    catch(error){
        throw error;
    }
}

export const verDocumentoHito = async(query) => {
    try {
        const response = await client.verDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetDespachos = async (query) => {
    try {
        const response = await client.get(`proceso-judicial/despachos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const serviceGetGenerales = async (query) => {
    try {
        const response = await client.get(`generales?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}